import React from "react";
import styles from "./UserTicketCard.module.css";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import Button from "@components/Button";

const UserTicketCard = ({ user, handleOpenTicketUpdate, viewNavigate }) => {
    return (
        <div className={styles.card}>
            <div className={styles.cardHead}>
                <div className={styles.cardIcon}>
                    <p>Id:{user.id}</p>
                    <KeyboardDoubleArrowRightIcon 
                        sx={{ fontSize: "2.5rem", backgroundColor:"#000", color:"#ffff", borderRadius:"50%", cursor:"pointer" }}
                        onClick={() => handleOpenTicketUpdate(user)}
                    />
                </div>
                <p>User: {user.userType}</p>
                <p>Updated By: {user.updatedBy}</p>
            </div>
            <Button 
                text="View >"
                onClick={() => viewNavigate(user)} 
            />
        </div>
    );
};

export default UserTicketCard;